// @flow
import React, { type Element } from 'react';
import { get } from 'lodash';
import { Carousel, CarouselItem, Modal } from 'angieslist-react-components';
import type { Image } from '../../../types';

const styles = {
  backgroundImg: url => ({
    width: '100%',
    height: '100%',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '50% 50%',
    backgroundImage: `url(${url})`,
  }),
  titleCaption: {
    backgroundColor: 'rgba(0,0,0,.65)',
    right: 0,
    left: 0,
    bottom: 0,
    padding: '0 20px',
    textAlign: 'left',
  },
  imageBtn: {
    border: 'none',
    outline: 'none',
    padding: 0,
    margin: 0,
    display: 'block',
    backgroundColor: 'white',
    width: '100%',
    height: '100%',
  },
};

type Props = {
  images: Image[],
  title: string,
  index: number,
  children: Element<*>,
};

type State = {
  direction: ?string,
  indx: number,
  open: boolean,
};

class ThumbnailImageModalComponent extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      direction: null,
      indx: props.index,
      open: false,
    };
  }
  state: State;
  componentWillReceiveProps(nextProps: Props) {
    const { index } = nextProps;
    const { open } = this.state;
    if (!open) {
      this.setState(() => ({
        indx: index,
      }));
    }
  }

  componentWillUnmount() {
    this.setState(() => ({ open: false }));
  }
  props: Props;

  render(): Element<"div"> {
    const {
      images, index, title, children,
    } = this.props;
    const { direction, indx, open } = this.state;
    const handleClose = () => this.setState(() => ({
      indx: index,
      open: false,
    }));
    return (
      <div style={{ width: '100%', height: '100%' }}>
        <Modal
          {...{ title }}
          show={open}
          onHide={handleClose}
        >
          <Modal.Body>
            <Carousel
              activeIndex={indx}
              direction={direction}
              onSelect={(selectedIndex, selectedDirection) => {
                this.setState(() => ({
                  indx: selectedIndex,
                  direction: selectedDirection,
                }));
              }}
            >
              {images.map((img, i) => {
                const imgTitle = get(img, 'title', '');
                const caption = get(img, 'caption', '');
                const url = get(img, 'url', '');
                return (
                  <CarouselItem key={img.id}>
                    <div className="gallery-carousel-img-wrapper">
                      <div style={styles.backgroundImg(url)} />
                    </div>
                    <If condition={imgTitle || caption}>
                      <div style={styles.titleCaption} className="carousel-caption">
                        <If condition={imgTitle}>
                          <h4>{imgTitle}</h4>
                        </If>
                        <If condition={caption}>
                          <p>{caption}</p>
                        </If>
                      </div>
                    </If>
                  </CarouselItem>
                );
              })}
            </Carousel>
          </Modal.Body>
        </Modal>
        <button
          id="thumbnail-image-modal--button"
          className="gallery-image-btn"
          style={styles.imageBtn}
          onClick={() => this.setState(() => ({ open: true }))}
        >
          {children}
        </button>
      </div>
    );
  }
}

export default ThumbnailImageModalComponent;



// WEBPACK FOOTER //
// ./src/modules/store/browser/components/reviews/ThumbnailImageModal.js